function formatCents(cents) {
  // Convert cents to "$12.34" format
  return '$' + (cents / 100).toFixed(2);
}

function updateDrawerCheckoutPrice() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const formattedTotal = formatCents(cart.total_price);
      const priceEl = document.querySelector('.cart-drawer .price-value');
      if (priceEl) {
        priceEl.textContent = formattedTotal;
      }
    });
}

document.addEventListener('DOMContentLoaded', function () {
  // Initial update when page loads
  updateDrawerCheckoutPrice();

  // Update when drawer changes (due to discount, quantity change, etc.)
  const cartDrawer = document.getElementById('Cart-Drawer');
  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      updateDrawerCheckoutPrice();
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }

  // Optional: run update when discount is applied via button
  const applyBtn = document.querySelector('button[type="submit"], button[onclick*="discount"]');
  if (applyBtn) {
    applyBtn.addEventListener('click', () => {
      setTimeout(updateDrawerCheckoutPrice, 1000);
    });
  }
});
